// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__nxlDe","button":"Tooltip_button__rztxE","flex":"Tooltip_flex__R1jJ4","icon":"Tooltip_icon__e569A"};